import React from 'react';
import { BoxBg, Heading } from './styled';
import { Text } from '../../styled';

const NotCoveredBox = () => {
  return (
    <BoxBg>
      <Heading>Important to know</Heading>
      <Text>
        We don't cover pre-existing conditions, high-risk or professional sport activity,
        cancer, or maternity. We don't cover flights, accommodations or excursions that
        were canceled or certain lost/stolen belongings.
      </Text>
    </BoxBg>
  );
};

export default NotCoveredBox;
